import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=162f665b"
import script from "./CarForm.vue?vue&type=script&lang=js"
export * from "./CarForm.vue?vue&type=script&lang=js"
import style0 from "./CarForm.vue?vue&type=style&index=0&id=162f665b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports